// extracted by mini-css-extract-plugin
module.exports = {"root":"MainHeader_root__P6dyq","title":"MainHeader_title__3uxIL","logout":"MainHeader_logout__2L3_n"};